'use client';

import { useCallback, useState } from 'react';

const useHeaderSearchSheet = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const closeSearch = useCallback(() => {
    setIsSearchOpen(false);
  }, []);

  const openSearch = useCallback(() => {
    setIsSearchOpen(true);
  }, []);

  return {
    closeSearch,
    isSearchOpen,
    openSearch,
  };
};

export default useHeaderSearchSheet;
